import "./App.css";
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { About } from './components/About';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Hero />
      <Benefits />
      <About />
      <FinalCTA />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
